import { React, useState } from "react";
import { Image } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import xclose from '../../assets/icons/x-close.svg';
import { toLower } from "lodash";

const WariningAlertModal = (props) => {
  console.log("props of confirmation box",props);
  
  let formName = props.formName;
  const closeTab = () => {
    window.close();
  };

  return (
      <Modal
        className="confirmAlertModal"
        show={props.show}
        onHide={props.handleClose}
        animation={false}
        backdrop="static"
      >
        <br></br>
        <Modal.Header className="confirm-modal">
                <Modal.Title className="confirmation-header">{props.action==="Add" ? "Add new ":"Edit "}{toLower(formName)}</Modal.Title>
                <Image className="cross-btn-confirm" src={xclose} onClick={() => props.handleClose()}></Image>
            </Modal.Header>
        <Modal.Body className="confirmcss">
         <div className="confirmation-body"> {props.waringMessage} ?</div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start confirmation-footer" >
          <Button variant="primary" onClick={() => props.handleYes()} className="modal-btn-sub">
            Yes
          </Button>
          <Button variant="outline-primary" onClick={() => props.handleClose()} className="modal-btn-sub">
            No
          </Button>
        </Modal.Footer>
      </Modal>
  );
};

export default WariningAlertModal;
